import React, { useState, useEffect, useContext } from "react";
import "./forma.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";
import { API_URL } from "../components/api";
import LanguageContext from "../context/LanguageContext";

function Formo(props) {
  let [notes, setvillage] = useState([]);
  let [employee, setemployee] = useState([]);

  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  let { user } = useContext(AuthContext);
  const { t } = useContext(LanguageContext);
  let r = props.remote;
  let o = props.office;
  let p=props.potential;
  let initialFreeCollection=props.freeCollection;
  let [remote, setRemote] = useState(r); // New state for remote, default value 0
  let [office, setOffice] = useState(o);
  let [potential,setPotential]=useState(p);
  let [freeCollection, setFreeCollection] = useState(initialFreeCollection);
  let [group, setgroup] = useState(""); // New state for remote, default value 0

  useEffect(() => {
    setFreeCollection(props.freeCollection);
  }, [props.freeCollection]);

  useEffect(() => {
    let isMounted = true;

    const getvillage = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/villages/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: "admin",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setvillage(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const getpermissions = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setgroup(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const getemployee = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/employees/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: "admin",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setemployee(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getvillage();
    getemployee();
    getpermissions();

    return () => {
      isMounted = false;
    };
  }, []);

  // Rest of the component code
  const options = notes.map((item) => {
    return {
      label: item.village_name,
      value: item.village_id,
    };
  });
  const employees = employee.map((item) => {
    return {
      label: item.first_name,
      value: item.employee_id,
    };
  });
  console.log(props.remote);
  let vilo = props.vill;
  let v = props.sub;

  let f = props.add;
  let l = props.inf;
  let y = props.fir;
  let z = props.mid;
  let d = props.las;
  let i = props.pho;
  let k = props.addr;
  let b = props.balance;
  let col = props.collector;
  const [firstname, setfirst] = useState(y ?? "");
  const [middlename, setmiddles] = useState(z ?? "");
  const [lastname, setlast] = useState(d ?? "");
  const [address, setaddress] = useState(k ?? "");
  const [phone, setphone] = useState(i ?? "");
  const [balance, setbalance] = useState(b ?? "");
  const [collector, setcollector] = useState(props.collector_id ?? "");
  const [category, setcategory] = useState(props.cat ?? "");
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [firstnameAr, setfirstAr] = useState(props.first_name_ar ?? "");
  const [middlenameAr, setmiddleAr] = useState(props.middle_name_ar ?? "");
  const [lastnameAr, setlastAr] = useState(props.last_name_ar ?? "");
  const AR_ONLY = /^[\u0600-\u06FF\s]+$/;
  const changed = (value, original) =>
    String(value ?? "") === String(original ?? "") ? "" : value;
  const arInvalid = (value, original) =>
    changed(value, original) !== "" && !AR_ONLY.test(value);
  const arHasError =
    arInvalid(firstnameAr, props.first_name_ar) ||
    arInvalid(middlenameAr, props.middle_name_ar) ||
    arInvalid(lastnameAr, props.last_name_ar);

  const balance_id = props.balance_id;
  console.log(collector);
  const [village, setvill] = useState(props.village_id ?? "");
  let handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setSaveError("");
    const rowEdits = {};
    const track = (key, value, original) => {
      const next = changed(value, original);
      if (next !== "") rowEdits[key] = next;
    };
    track("first_name", firstname, y);
    track("middle_name", middlename, z);
    track("last_name", lastname, d);
    track("first_name_ar", firstnameAr, props.first_name_ar);
    track("middle_name_ar", middlenameAr, props.middle_name_ar);
    track("last_name_ar", lastnameAr, props.last_name_ar);
    track("phone_number", phone, i);
    track("address_string", address, k);
    track("village_id", village, props.village_id);
    track("employee_id", collector, props.collector_id);
    track("category", category, props.cat);
    track("balance_usd", balance, b);
    if (rowEdits.village_id !== undefined) {
      const opt = options.find((o) => String(o.value) === String(rowEdits.village_id));
      if (opt) rowEdits.village_name = opt.label;
    }

    Axios.post(
      `${API_URL}/administration/clients/`,
      {
        client_id: v,
        info_id: l,
        address_id: f,
        Action: "Put",
        first_name: changed(firstname, y),
        email_address: "-",
        address_string: changed(address, k),
        phone_number: changed(phone, i),
        middle_name: changed(middlename, z),
        last_name: changed(lastname, d),
        first_name_ar: changed(firstnameAr, props.first_name_ar),
        middle_name_ar: changed(middlenameAr, props.middle_name_ar),
        last_name_ar: changed(lastnameAr, props.last_name_ar),
        village_id: changed(village, props.village_id),
        collector_id: changed(collector, props.collector_id),
        balance_id: balance_id,
        category: changed(category, props.cat),
        balance: changed(balance, b),
        remote: remote, // Include remote in the POST request payload
        office: office, // Include office in the POST request payload
        potential: potential,
        free_collection: freeCollection,

        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        setIsSaving(false);

        if (props.onSuccess) {
          props.onSuccess(freeCollection, rowEdits);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsSaving(false);
        setSaveError(
          "Unable to update client. Please try again."
        );
      });
  };
  const dua = [
    { value: "VIP", label: "VIP" },
    { value: "Standard", label: "Standard" },
    { value:"Special", label:"Special"},
    { value:"Blacklist", label:"Blacklist"},
  ];
  return (
    <div className="mod">
      <form onSubmit={handleSubmit}>
        <div className="name">
          <div className="form-group">
            <label>
              First Name:
              <input
                className="form-control"
                type="text"
                value={firstname}
                placeholder={y}
                onChange={(e) => setfirst(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Middle Name:
              <input
                className="form-control"
                type="text"
                value={middlename}
                placeholder={z}
                onChange={(e) => setmiddles(e.target.value)}
              />
            </label>
          </div>

          <div className="form-group">
            <label>
              Last Name:
              <input
                className="form-control"
                type="text"
                value={lastname}
                placeholder={d}
                onChange={(e) => setlast(e.target.value)}
              />
            </label>
          </div>
        </div>
        <div className="name">
          <div className="form-group">
            <label>
              {t("clientForm.firstNameAr")}
              <input
                className={arInvalid(firstnameAr, props.first_name_ar) ? "form-control is-invalid" : "form-control"}
                type="text"
                dir="rtl"
                value={firstnameAr}
                placeholder={t("clientForm.phFirstNameAr")}
                onChange={(e) => setfirstAr(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              {t("clientForm.middleNameAr")}
              <input
                className={arInvalid(middlenameAr, props.middle_name_ar) ? "form-control is-invalid" : "form-control"}
                type="text"
                dir="rtl"
                value={middlenameAr}
                placeholder={t("clientForm.phMiddleNameAr")}
                onChange={(e) => setmiddleAr(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              {t("clientForm.lastNameAr")}
              <input
                className={arInvalid(lastnameAr, props.last_name_ar) ? "form-control is-invalid" : "form-control"}
                type="text"
                dir="rtl"
                value={lastnameAr}
                placeholder={t("clientForm.phLastNameAr")}
                onChange={(e) => setlastAr(e.target.value)}
              />
            </label>
          </div>
        </div>

        <label>
          Phone:
          <input
            className="form-control"
            type="number"
            value={phone}
            placeholder={i}
            onChange={(e) => setphone(e.target.value)}
          />
        </label>
        <label>
          Address:
          <input
            className="form-control"
            type="text"
            value={address}
            placeholder={k}
            onChange={(e) => setaddress(e.target.value)}
          />
        </label>
        <label>
          Village:
          <Select
            className="search-line"
            placeholder={vilo}
            value={options.find((o) => String(o.value) === String(village)) || null}
            options={options}
            onChange={(opt) => setvill(opt.value)}
          />
        </label>
        <label>
          Balance:
          <input
            className="form-control"
            type="text"
            value={balance}
            placeholder={b}
            onChange={(e) => setbalance(e.target.value)}
            disabled={group !== "yes"} // Disable unless group is 'yes'
          />
        </label>
        <label>
          Collector:
          <Select
            className="search-line"
            placeholder={props.employee_en}
            value={employees.find((o) => String(o.value) === String(collector)) || null}
            options={employees}
            onChange={(opt) => setcollector(opt.value)}
          />
        </label>
        <label>
          Category:
          <Select
            className="search-line"
            options={dua}
            placeholder={props.cat}
            value={dua.find((o) => o.value === category) || null}
            onChange={(opt) => setcategory(opt.value)}
          />
        </label>
        <div
          className="form-group"
          style={{ display: "flex", alignItems: "center" }}
        >
          <label style={{ marginRight: "10px" }}>Temp Collection:</label>
          <input
            type="checkbox"
            checked={remote === 1}
            onChange={(e) => setRemote(e.target.checked ? 1 : 0)}
            style={{ width: "20px", height: "20px" }}
          />
        </div>
        <div
          className="form-group"
          style={{ display: "flex", alignItems: "center" }}
        >
          <label style={{ marginRight: "10px" }}>Temp Collection Office:</label>
          <input
            type="checkbox"
            checked={office === 1}
            onChange={(e) => setOffice(e.target.checked ? 1 : 0)}
            style={{ width: "20px", height: "20px" }}
          />
        </div>
        <div
          className="form-group"
          style={{ display: "flex", alignItems: "center" }}
        >
          <label style={{ marginRight: "10px" }}>Potential Client:</label>
          <input
            type="checkbox"
            checked={potential === 1}
            onChange={(e) => setPotential(e.target.checked ? 1 : 0)}
            style={{ width: "20px", height: "20px" }}
          />
        </div>
        <div
          className="form-group"
          style={{ display: "flex", alignItems: "center" }}
        >
          <label style={{ marginRight: "10px" }}>
            Free Collection:
          </label>
          <input
            type="checkbox"
            checked={freeCollection === 1}
            onChange={(e) =>
              setFreeCollection(e.target.checked ? 1 : 0)
            }
            style={{ width: "20px", height: "20px" }}
          />
        </div>
        {saveError && (
          <div className="alert alert-danger" role="alert">
            {saveError}
          </div>
        )}
        <div className="fo">
          <button
            type="submit"
            className="btn btn-primary btn-md"
            disabled={isSaving || arHasError}
          >
            {isSaving ? "Saving..." : "Edit"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Formo;
